import { map } from 'lodash'

import { API, MOCK_DATA } from '@/constants'
import { axiosServer as axios } from '@/base/axios'

import { WPPageData } from '@/types'

export const normalizePostsCollection = (
  collection: any[],
  // eslint-disable-next-line no-unused-vars
  strings?: Record<string, any>,
  // eslint-disable-next-line no-unused-vars
  locale?: string
) => {
  return map(
    collection,
    ({ id, title, image, featured_image, paragraph, content }, index) => ({
      uuid: `${id || index + 1}`,
      title: title?.rendered || title || null,
      paragraph: content?.rendered || paragraph || null,
      media: {
        use_video: false,
        image: featured_image || image || null
      }
    })
  )
}

export const normalizeRelationalSection = (
  section: any,
  pageData: WPPageData,
  locale?: string
) => {
  const type = section.collection_type
  const collection = section[type] || section.collection

  return {
    ...section,
    collection: normalizePostsCollection(collection, pageData, locale)
  }
}

export const normalizeRelationalArchive = async (
  section: any,
  pageProps: WPPageData,
  locale?: string
) => {
  // const { labels } = pageData

  return {
    ...(await normalizeRelationalSection(section, pageProps, locale))
    /* ...(section.filter_terms.length > 0
      ? {
          filters: {
            filter: {
              label: labels?.filter_by,
              placeholder: labels?.selection,
              options: map(section.filter_terms, ({ name, term_id }: any) => ({
                label: name,
                value: term_id
              }))
            }
          }
        }
      : null) */
  }
}

export const mapPageStaticProps = async (
  pageProps: WPPageData,
  // eslint-disable-next-line no-unused-vars
  locale?: string
) => {
  return {
    ...pageProps,
    acf: {
      ...pageProps.acf,
      builder: await Promise.all(
        map(pageProps.acf.builder, async (section: any) => section)
      )
    }
  }
}

export const mapOptionsDataProps = async (optionsData: any) => {
  const { form_id } = optionsData.modals.form
  const {
    data: { fields, button }
  } = MOCK_DATA
    ? { data: require(`@/data/forms/newsletter.json`) }
    : await axios.get(`${API.GRAVITY_FORM}/${form_id}/`)

  return {
    ...optionsData,
    modals: {
      ...optionsData.modals,
      form: {
        ...optionsData.modals.form,
        fields,
        button
      }
    }
  }
}
